import FormHead from "../RecordPage/FormHead";
import { useState, useRef, useEffect } from "react";
import { GetSearchData, SendDrugRecord } from "./FetchData";
import { getToday } from "../RecordPage/GetToday";
import {drug_name_list} from "../../Variables/drugInfo"

const today=getToday();

function AddDrugRecord({patientData}) {
    const [originRecord, setOriginRecord] = useState({});
    const [webpageRecord, setWebpageRecord] = useState({});
    const [recordDates, setRecordDates] = useState([]);
    const [outletDatas, setOutletDatas] = useState([]);
    const [deleteIDList, setDeleteIDList] = useState([]);
    const [lastDate, setLastDate] = useState(null);
    const [sendOnClick, setSendOnClick] = useState(false);

    const dateRef = useRef(null);
    const dateInputRef = useRef(null);

    const pushNewRecord = () => {
        setOutletDatas([...outletDatas, {record_id: "", name: "ACETAZOLAMIDE", freq: "", duration: ""}])
    }

    const updateOutlet = (index, target, value) => {
        let temOutlet = [...outletDatas];
        temOutlet[index][target] = value!=="" ? value : null;
        setOutletDatas(temOutlet);
    }

    const deleteRecord = (indexToDelete) => {
        const updatedItems = outletDatas.filter((item, index) => index !== indexToDelete);
        if(outletDatas[indexToDelete].record_id && outletDatas[indexToDelete].record_id!==''){
            if(!deleteIDList.includes(outletDatas[indexToDelete].record_id))setDeleteIDList([...deleteIDList, outletDatas[indexToDelete].record_id]);
        }
        setOutletDatas(updatedItems);
    };

    const newDrugLine = (recordInput, index) => {
        return(
            <tr className="ml-2 text-center">
                <td></td>
                <td>
                    <select value={recordInput.name} onChange={(event) => updateOutlet(index, "name", event.target.value)}>{Object.entries(drug_name_list).map(([name, fullname])=>(<option key={name} value={name}>{fullname}</option>))}</select>
                </td>
                <td>
                    <input type="text" value={recordInput.freq} onChange={(event) => (updateOutlet(index, "freq", event.target.value))} style={{border: "solid 1px gray", borderRadius: "0.1em"}} className="m-1 px-1" required="required" ></input>
                </td>
                <td>
                    <input type="number" value={recordInput.duration} onChange={(event) => (updateOutlet(index, "duration", event.target.value))} style={{border: "solid 1px gray", borderRadius: "0.1em"}} className="m-1 px-1" required="required" ></input>
                </td>
                <td>
                    <button className="py-1 px-2 bg-[#0000] text-[#ff0000] text-3xl" style={{borderRadius:".5em"}} onClick={(event) => deleteRecord(index)}>-</button> 
                </td>
            </tr>
        )
    }

    const changeDate = async(newDate) => {
        await updateWebpageData(outletDatas);
        setOutletDatas(JSON.parse(JSON.stringify(webpageRecord[newDate])));
        // setDeleteIDList((webpageRecord.deleteIDList) ? webpageRecord.deleteIDList : [])
    }

    const updateWebpageData = async(dataInput) => {
        let temUpdateList = {};
        let date = lastDate;
        // console.log(originRecord, webpageRecord)
        dataInput.forEach((record, index) => {
            if(record.record_id===""){
                temUpdateList[index] = record;
            }
            else{
                let updatedItems = {};
                Object.entries(record).forEach(([item, value]) => {
                    let temIndex = index;
                    while(deleteIDList.includes(originRecord[date][temIndex].record_id))temIndex++;
                    if(value !== originRecord[date][temIndex][item]){
                        // console.log(value)
                        updatedItems.record_id = record.record_id;
                        updatedItems[item] = value;
                    }
                })
                if(Object.keys(updatedItems).length>0){temUpdateList[index] = updatedItems;}
            }
        })
        setWebpageRecord(prevState => ({
            ...prevState, 
            [date]: dataInput,
            updateList: {
                ...prevState.updateList,
                [date]: temUpdateList
            },
            deleteIDList:  deleteIDList
        }))
    }

    const deleteToday = () => {
        if(outletDatas.length>0){
            let temData = outletDatas;
            let temDeleteList = deleteIDList;
            temData.forEach((record) => {
                if(!record.record_id || record.record_id==='')return;
                if(!deleteIDList.includes(record.record_id))temDeleteList.push(record.record_id);
            })
            setDeleteIDList(temDeleteList);
        }
        setOutletDatas([]);
    }

    const recoverToday = () => {
        if(originRecord[dateRef.current.value]){       
            let recoveredDeleteIDList = deleteIDList;
            originRecord[dateRef.current.value].forEach(record => {
                if(deleteIDList.includes(record.record_id)){
                    recoveredDeleteIDList.splice(recoveredDeleteIDList.indexOf(record.record_id),1)
                }
            })
            setWebpageRecord(prevState => (
                {
                    ...prevState,
                    [dateRef.current.value]: JSON.parse(JSON.stringify(originRecord[dateRef.current.value])),
                    deleteIDList: recoveredDeleteIDList,
                    updateList: {
                        ...prevState.updateList,
                        [dateRef.current.value]: {}
                    }
                }
            ))
        }
        else{
            setWebpageRecord(prevState => (
                {
                    ...prevState,
                    [dateRef.current.value]: [],
                    updateList: {
                        ...prevState.updateList,
                        [dateRef.current.value]: {}
                    }
                }
            ))
        }
    }

    const addNewDate = (newDate) => {
        if(!newDate)return;
        if(!recordDates.includes(newDate))setRecordDates([...recordDates, newDate]);
        if(!webpageRecord.hasOwnProperty(newDate)){
            setWebpageRecord(prevState => (
                {
                    ...prevState,
                    [newDate]: []
                }
            ))
        }
    }

    const sendDataToServer = async() => {
        await updateWebpageData(JSON.parse(JSON.stringify(outletDatas)))
        // sendDrugRecord(webpageRecord, patientData.client_data_record_id);
        setSendOnClick(true);
    }

    let returnValue = GetSearchData("drug_record/"+patientData.client_data_record_id);
    // let [returnValue, setNothing] = useState([{start_date: "2024-07-18", record_id: 1, drug:"ACETAZOLAMIDE", drug_frequency:"Q4D", drug_due_day: 3},{start_date: "2024-07-18", record_id: 10, drug:"ACETAZOLAMIDE", drug_frequency:"Q4D", drug_due_day: 32}]);

    useEffect(() => {
        if(Array.isArray(returnValue)){
            console.log('return:',returnValue)
            try{
                let temRecords = {};
                let temDate = [];
                returnValue.forEach((record)=>{
                    if(!temRecords.hasOwnProperty(record.start_date))temRecords[record.start_date] = [];
                    temRecords[record.start_date].push(
                        {
                            record_id: record.record_id,
                            name: record.drug,
                            freq: record.drug_frequency,
                            duration: record.drug_due_day,
                        }
                    );
                    if(!temDate.includes(record.start_date))temDate.push(record.start_date);
                })

                temDate.sort();
                setOriginRecord(JSON.parse(JSON.stringify(temRecords)));
                setWebpageRecord(JSON.parse(JSON.stringify(temRecords)));
                setRecordDates(temDate);
            }
            catch(error){
                console.log("error:",error)
            }
        }
    }, [returnValue])

    useEffect(() => {
        try{
            setOutletDatas(JSON.parse(JSON.stringify(webpageRecord[dateRef.current.value])))
            console.log("update success", webpageRecord.updateList, webpageRecord.deleteIDList)
            setLastDate(dateRef.current.value);
        }
        catch(error){
            console.log("error:",error)
        }
    }, [webpageRecord, dateRef])

    useEffect(() => {
        if(sendOnClick){
            SendDrugRecord(webpageRecord, patientData.client_data_record_id)
            .then(() => {
                let tem = webpageRecord;
                delete tem.deleteIDList;
                delete tem.updateList;
                Object.entries(tem).forEach(([key, value]) => {
                    value.forEach(record => {
                        if(record.record_id==="")record.record_id = "updated";
                    })
                });

                setWebpageRecord(JSON.parse(JSON.stringify(tem)));
                setOriginRecord(JSON.parse(JSON.stringify(tem)));
                setDeleteIDList([]);
                setOutletDatas([]);
                setSendOnClick(false);
            })
            .catch(error => {
                console.log(error)
            })
        }
    }, [sendOnClick])

    return (
        <div className="text-xl">
            {webpageRecord.length===0 ? <div>{returnValue}</div> : 
                <>
                    <table name="FormHeadExtend" className="m-auto ">
                        <tr>
                            <FormHead patient_name={patientData.name}></FormHead>
                        </tr>
                        <tr>
                            <td>
                                <div className="flex align-middle">
                                    取藥日期：
                                    <select ref={dateRef} onChange={(event) => changeDate(event.target.value)}>{recordDates.map((date) => (<option key={date} value={date}>{date}</option>))}</select><br></br>
                                </div>
                            </td>
                            <td>
                                <div className="flex align-middle">
                                <button className="m-1 py-1 px-2 bg-[#ffae00] text-[#fff]" style={{borderRadius:".5em"}} onClick={() => dateInputRef.current.showPicker()} onBlur={(event) => addNewDate(dateInputRef.current.value)}>新增日期</button>
                                <input type="date" max={today} ref={dateInputRef} className=" invisible" onBlur={(event) => addNewDate(event.target.value)}></input><br/>
                                </div>
                            </td>
                        </tr>
                    </table>
                    <div className=" flex flex-wrap justify-center pt-2">
                    <table className="w-4/5 border-l-4 border-l-[#ffd500]">
                        <tr className="text-center bg-[#bfbfbf]">
                            <td className="w-10 bg-[#D9EFEC] py-6"></td>
                            <td className="rounded-l-lg">藥物名稱</td>
                            <td>頻率</td>
                            <td>總天數</td>
                            <td className="rounded-r-lg"></td>
                        </tr>

                        {outletDatas ? outletDatas.map((record, index) => (<>{newDrugLine(record, index)}</>)) : <></>}
                        
                        <tr><td></td><td><button className="py-1 px-2 bg-[#0000] text-[#ff0000] text-3xl" style={{borderRadius:".5em"}} onClick={() => pushNewRecord()}>+</button></td></tr>
                        <tr></tr>
                        <tr>
                            <td colSpan={2}></td>
                            <td colSpan={3}>
                                <div className="flex justify-between">
                                    <button className="py-2 px-4 bg-[#399b25] text-[#fff]" style={{borderRadius:".5em"}} onClick={(event) => sendDataToServer()}>上傳所有記錄</button>
                                    <button className="py-2 px-4 bg-[#7231ff] text-[#fff]" style={{borderRadius:".5em"}} onClick={() => recoverToday()}>還原本日資料</button>
                                    <button className="py-2 px-4 bg-[#ff3c3c] text-[#fff]" style={{borderRadius:".5em"}} onClick={(event) => deleteToday()}>清空本日資料</button>
                                </div>
                            </td>
                        </tr>
                    </table>
                    </div>
                </>
            }
        </div>
    )
}

export default AddDrugRecord;
